// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--MNKNH","image":"card-module--image--3N6Hj","title":"card-module--title--34OV0","description":"card-module--description--3geL4"};